// use-sessions-filters.ts — Sessions-list suite, subscription
//
// Read/write the sidebar filter state. Sync — no `await` involved.

'use client';

import { useCallback } from 'react';
import {
  useSessionsListContext,
  type SessionsFilters,
} from './SessionsListProvider';

const FILTER_KEY = {
  Search: 'search',
  Archived: 'archived',
  IncludeSessionId: 'includeSessionId',
} as const satisfies Record<string, keyof SessionsFilters>;

export function useSessionsFilters(): {
  filters: SessionsFilters;
  setSearch: (search: string) => void;
  setArchived: (archived: boolean) => void;
  setIncludeSessionId: (sessionId: string | null) => void;
} {
  const { filters, setFilter } = useSessionsListContext();

  const setSearch = useCallback(
    (search: string) => setFilter(FILTER_KEY.Search, search),
    [setFilter],
  );
  const setArchived = useCallback(
    (archived: boolean) => setFilter(FILTER_KEY.Archived, archived),
    [setFilter],
  );
  const setIncludeSessionId = useCallback(
    (sessionId: string | null) => setFilter(FILTER_KEY.IncludeSessionId, sessionId),
    [setFilter],
  );

  return { filters, setSearch, setArchived, setIncludeSessionId };
}

export type { SessionsFilters };
